const MIDDLEGROUND_RANGE = 256;
const OUTER_LAYER_FACTOR = .1;

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function updateWaistbandMiddlegroundParallax(waistband) {
  const background = waistband.querySelector('.background');
  const middleground = waistband.querySelector('.middleground');
  const foreground = waistband.querySelector('.foreground');

  if (!middleground) {
    return;
  }

  const rect = waistband.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const progress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
  const offset = (progress - 0.5) * MIDDLEGROUND_RANGE;
  const outerLayerOffset = offset * OUTER_LAYER_FACTOR;

  middleground.style.transform = `translate3d(0, ${offset}px, 0)`;

  if (background) {
    background.style.transform = `translate3d(0, ${outerLayerOffset}px, 0)`;
  }

  if (foreground) {
    foreground.style.transform = `translate3d(0, ${outerLayerOffset}px, 0)`;
  }
}

function initWaistbandParallax() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const waistbands = Array.from(document.querySelectorAll('.waistband'));

  if (prefersReducedMotion || waistbands.length === 0) {
    return;
  }

  let ticking = false;

  const onScrollOrResize = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(() => {
      waistbands.forEach((waistband) => updateWaistbandMiddlegroundParallax(waistband));
      ticking = false;
    });
  };

  onScrollOrResize();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
}

initWaistbandParallax();